import * as React from 'react';

import { CardLink } from './CardLink';
import { Header } from '../Common/common.styles';
import { Heading2 } from '../Text';
import { ICards } from '../../../src/models/content.interfaces';
import { ProductCardsContainer } from './ProductCards.styles';

export const ProductCards = ({ items }: ICards) => {
  return (
    <div data-id="product-cards-container">
      <Header>
        <Heading2 data-id="leading">
          Offering more than just energy plans &amp; highly rated customer service
        </Heading2>
      </Header>
      <ProductCardsContainer>
        {items.map((i, index) => (
          <CardLink {...i} key={index} />
        ))}
      </ProductCardsContainer>
    </div>
  );
};
